import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./transaction_type.js";
//#region src/transaction_type_helper.ts
var transaction_type_helper_exports = /* @__PURE__ */ __exportAll({ stringFromEnum: () => stringFromEnum });
function stringFromEnum(type) {
	switch (type) {
		case 0: return "sale";
		case 1: return "refund";
	}
}
//#endregion
export { stringFromEnum, transaction_type_helper_exports };

//# sourceMappingURL=transaction_type_helper.js.map